module.exports = __webpack_public_path__ + "static/media/keyvisual-radeberger-1x.14d17562.jpg";